module.exports = __webpack_public_path__ + "static/media/envoi_xlarge.72dc36b5.png";